import classNames from 'classnames'
import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { useAccountReadContext } from '@context/AccountContextContext'
import { AuthSessionContext } from '@context/AuthContext'

import { Button } from '@ui/components/Button'

import { formatDate } from '@utils/date.utils'
import { CommonPaths } from '@utils/path'

import { NotificationDanger } from '@global/notification/notification'

import styles from './YearlyKycUpdateDetailsForm/YearlyKycUpdateDetailsForm.module.scss'

export const YearlyKycUpdateDetailsNotification: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { account } = useAccountReadContext()
  const [auth] = useContext(AuthSessionContext)
  const dateFormat = auth?.dateFormatType?.name

  const goToKycDetails = () => {
    navigate(CommonPaths.KycUpdateDetails)
  }

  return (
    <NotificationDanger
      title={t('Profile.Warning please update your details')}
      subtitle={
        <React.Fragment>
          <p>
            {t(
              'WarningMessage.Please acknowledge and update your profile with the most accurate information'
            )}
          </p>
          <p>
            <Trans i18nkey={t('WarningMessage.Kyc Update Details Message')}>
              {t('Profile.Please note that if the information is not acknowledged before')}{' '}
              <span className={styles.textStrong}>
                {account?.detailsUpdateAvailableUntil && (
                  <React.Fragment>
                    {formatDate(account.detailsUpdateAvailableUntil, {
                      formatType: dateFormat,
                    })}{' '}
                  </React.Fragment>
                )}
              </span>{' '}
              {t('Profile.then you will automatically redirected to update details page.')}
            </Trans>
            <div className={classNames(styles.detailsWrapper, 'pt-3')}>
              <Button.Primary size='md' onClick={goToKycDetails}>
                {t('Profile.Update Details')}
              </Button.Primary>
            </div>
          </p>
        </React.Fragment>
      }
    />
  )
}
